export default __webpack_public_path__ + "static/media/signup.b4c26f8f.png";